"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  data: function data() {
    return {
      checked: false,
      show: false
    };
  },
  methods: {
    checkboxChange: function checkboxChange() {
      this.$emit('change', this.checked);
    },
    change: function change() {
      this.checked = !this.checked;
      this.$emit('change', this.checked);
    },
    confirm: function confirm() {
      this.checked = true;
      this.$emit('change', this.checked);
      this.show = false;
    }
  }
};